import React from 'react'
import {Login} from "./container/login";

const App = () => (
    <main className={'super-admin--page-login'}>
        <Login />
    </main>
)

export default App;